const translation = {
  // Navigation
  nav_home: 'Startseite',
  nav_gallery: 'Galerie',
  nav_features: 'Eigenschaften',
  nav_location: 'Lage',
  nav_contact: 'Kontakt',

  // Hero Section
  hero_title: 'Zeitgenössischer Luxus im Herzen Norditaliens',
  hero_subtitle: 'Gesamtfläche: 505m² | Gewerbefläche: 667,31m² | Außenfläche: 1.190m² | Energieklasse A3 | Smart-Home-Technologie | beheizter Salzwasserpool',
  hero_cta: 'Besichtigung vereinbaren',
  hero_learn_more: 'Mehr erfahren',
  hero_property_info: 'Gesamtfläche: 505m² | Gewerbefläche: 667,31m² | Außenfläche: 1.190m² | Energieklasse A3 | Smart-Home-Technologie | beheizter Salzwasserpool',

  // Key Info
  key_info_title: 'Immobilienübersicht',
  key_info_size: 'Wohnfläche',
  key_info_size_value: '350 m²',
  key_info_bedrooms: 'Schlafzimmer',
  key_info_bedrooms_value: '4',
  key_info_bathrooms: 'Badezimmer',
  key_info_bathrooms_value: '3',
  key_info_energy: 'Energieklasse',
  key_info_energy_value: 'A3',
  key_info_year: 'Baujahr',
  key_info_year_value: '2020',
  key_info_parking: 'Parkplatz',
  key_info_parking_value: 'Doppelgarage',

  // Description
  desc_title: 'Architektonische Exzellenz trifft auf modernes Wohnen',
  desc_p1: 'Im Außenbereich verfügt die Villa über einen beheizten Salzwasserpool mit LED-Beleuchtung. Das System integriert Chromotherapie-Optionen und arbeitet autonom für Salz‑ und pH‑Ausgleich.',
  desc_p2: 'Die Villa hat die Energieklasse A3. Energie wird durch zwei Photovoltaik‑Anlagen (insgesamt 20 kW) mit 40 kWh Speicher, einen Kondensatorkessel, 10 Solar‑Thermie‑Paneele und eine in drei Zonen aufgeteilte Fußbodenheizung bereitgestellt.',
  desc_p3: 'Die in der gesamten Immobilie verwendeten Materialien und Technologien sind hochwertig und wurden nach Funktionalität und Langlebigkeit ausgewählt: französischer Stein in wichtigen Innenbereichen (z. B. Küche, Bad), Marine‑Teak für die Schlafzimmer, maßgefertigte Tischlerei, integriertes Bang & Olufsen‑Audio‑Video‑System, Siemens‑, Bosch‑, Liebherr‑, KitchenAid‑ und Miele‑Geräte, Daikin‑Mehrzonen‑Klima‑Steuerung und zentrale Pool‑ & Bewässerungs‑Verwaltung.',
  desc_p4: 'Die Villa befindet sich in Arcisate, fußläufig (ca. 5 Min.) zum Bahnhof mit Direktverbindungen nach Varese, Mailand, Flughafen Malpensa, Como und Schweiz. Mit dem Auto ist Varese ca. 15 Min., Lugano (CH) ca. 30 Min. und Mailand bzw. Flughafen Malpensa 45‑60 Min. entfernt. Die Lage ermöglicht schnellen Zugang zu Grundversorgungen und Hauptverkehrswegen – ideal für Käufer, die effiziente Mobilität und ein technologisch fortschrittliches, kostengünstiges Objekt suchen.',

  // Amenities
  amenities_title: 'Premium‑Ausstattung',
  amenities_subtitle: 'Premium‑Funktionen für einen außergewöhnlichen Lifestyle',
  amenities_smart_home: 'Smart‑Home‑System',
  amenities_smart_home_desc: 'Vollständige Hausautomation für Beleuchtung, Klima und Sicherheit',
  amenities_heating: 'Fußbodenheizung',
  amenities_heating_desc: 'Zonen‑Strahlungsheizung im gesamten Anwesen',
  amenities_climate: 'Daikin‑Klima‑Steuerung',
  amenities_climate_desc: 'Premium‑HVAC‑System für optimalen Komfort',
  amenities_pool: 'Beheizter Salzwasserpool',
  amenities_pool_desc: 'LED‑Chromotherapie, automatische Salz‑ und pH‑Regulierung',
  amenities_audio: 'Bang & Olufsen‑System',
  amenities_audio_desc: 'Integriertes Audio‑Video im gesamten Haus',
  amenities_security: 'Sicherheitssystem',
  amenities_security_desc: 'Fortschrittliche Alarm‑ und CCTV‑Überwachung',
  amenities_wellness: 'Sauna & Wellness',
  amenities_wellness_desc: 'Privater Spa‑Bereich mit Sauna (im Bau)',
  amenities_fitness: 'Fitness‑Bereich',
  amenities_fitness_desc: 'Exklusiver Fitnessraum mit professioneller Ausstattung',
  amenities_wine: 'Weinkeller',
  amenities_wine_desc: 'Klimatisierte Lagerung für Ihre Sammlung',
  amenities_irrigation: 'Intelligente Bewässerung',
  amenities_irrigation_desc: 'Automatisches Gartenbewässerungssystem mit Regenwassersammlung',
  amenities_ev: 'EV‑Ladestation',
  amenities_ev_desc: 'Elektroauto‑Ladung in der Garage',
  amenities_solar: 'Solar‑Energiesystem',
  amenities_solar_desc: '20 kW Photovoltaik mit 40 kWh Batteriespeicher',

  // Gallery
  gallery_title: 'Immobiliengalerie',
  // ... (gallery entries unchanged)

  // Operating Costs
  costs_title: 'Betriebskosten & Energieeffizienz',
  costs_intro: 'Diese Villa wurde so konzipiert, dass die Betriebskosten unter Kontrolle bleiben, gleichzeitig das ganze Jahr über ein hohes Komfortniveau gewährleistet wird. Dank modernster Energiesysteme und Vor-Ort‑Produktion bleiben die Gesamtkosten im Verhältnis zu Größe und Leistung der Immobilie relativ niedrig.',
  costs_annual_title: 'Jährliche Betriebskosten (ca.):',
  costs_water: 'Wasser',
  costs_water_amount: '€635,20',
  costs_internet: 'Internet & Telefon',
  costs_internet_amount: '€424,68',
  costs_electricity_consumed: 'Stromverbrauch',
  costs_electricity_consumed_amount: '€2.038,17',
  costs_gas: 'Gas',
  costs_gas_amount: '€2.855,00',
  costs_total_utilities: 'Gesamt‑Nebenkosten',
  costs_total_utilities_amount: '€5.952,00',
  costs_electricity_sold: 'Stromverkauf zurück ins Netz',
  costs_electricity_sold_amount: '– €2.750,00',
  costs_waste_tax: 'Kommunale Abfallgebühr',
  costs_waste_tax_amount: '€485,75',
  costs_net_annual: 'Geschätzte Netto‑Jahreskosten',
  costs_net_annual_amount: '€3.687,00',
  costs_comfort_title: 'Komfort & Klima‑Steuerung:',
  costs_comfort_pool: 'Von Mai bis September wird der Außenpool (ca. 88.000 L) auf 28 °C geheizt.',
  costs_comfort_home: 'Das gesamte Haus wird das ganze Jahr über konstant bei 22 °C gehalten – Sommer mit Daikin‑Wärmepumpe, Winter mit Buderus‑Wärmepumpe für die Fußbodenheizung.',
  costs_image_caption: 'Bild‑Upload: Energie‑Dashboard, Pool oder technische Infografik.',

  // Operating Costs Details
  costs_details_intro: 'Geschätzte jährliche Betriebskosten basierend auf durchschnittlicher Nutzung. Tatsächliche Kosten können variieren.',
  costs_energy_desc: 'Strom‑ und Gasverbrauch',
  costs_water_desc: 'Wasserversorgung und Abwasser',
  costs_maintenance_desc: 'Regelmäßige Wartung und Instandhaltung',
  costs_estimate_title: 'Geschätzter Jahresenergieverbrauch',
  costs_estimate_heating: 'Heizung',
  costs_estimate_heating_value: '12.000 kWh/Jahr',
  costs_estimate_cooling: 'Kühlung',
  costs_estimate_cooling_value: '3.500 kWh/Jahr',
  costs_estimate_hot_water: 'Warmwasser',
  costs_estimate_hot_water_value: '4.200 kWh/Jahr',
  costs_estimate_appliances: 'Geräte & Beleuchtung',
  costs_estimate_appliances_value: '5.800 kWh/Jahr',
  costs_estimate_total: 'Gesamt (geschätzt)',
  costs_estimate_total_value: '25.500 kWh/Jahr',
  costs_estimate_note: 'Solar‑Paneele und Batteriespeicher reduzieren diese Kosten erheblich.',

  // ... (rest of the file unchanged)
};

export default translation;